export default "__VITE_ASSET__0XUdE87A__"